import { TRANSACTIONS_SLICE_NAME } from 'app/modules/transactions/sliceTransactions';

export const selectFilters = (state: RootState) =>
  state[TRANSACTIONS_SLICE_NAME].filters;
